export default __webpack_public_path__ + "static/media/img2.bdf964b1.jpg";